var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_390",
    "data-name": "Groupe 390",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.353,
    height: 42.357,
    viewBox: "0 0 42.353 42.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 42.353,
    height: 42.357,
    fill: "#ffa748"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_338",
    "data-name": "Groupe 338",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2826",
    "data-name": "Trac\\xE9 2826",
    d: "M42.353,10.757a13.106,13.106,0,0,1-.813,2.095,4.913,4.913,0,0,1-4.218,2.512c-1.79.07-3.584.037-5.377.015a1.645,1.645,0,0,1,.02-3.289c1.351-.024,2.7-.008,4.055-.009h.573c-.51-.719-.935-1.39-1.43-2A17.466,17.466,0,0,0,24.739,3.687a17.245,17.245,0,0,0-14,3.022A17.255,17.255,0,0,0,3.691,17.532a17.254,17.254,0,0,0,3.03,14.112,17.5,17.5,0,0,0,10.8,7.028,17.18,17.18,0,0,0,4.727.348,4.089,4.089,0,0,1,1.026.031,1.609,1.609,0,0,1,1.288,1.685,1.648,1.648,0,0,1-1.509,1.547A20.783,20.783,0,0,1,9.422,38.8,20.1,20.1,0,0,1,.678,26.436c-2.018-8.744.477-16.1,7.376-21.858A20.11,20.11,0,0,1,19.073.1c.286-.031.571-.065.857-.1h2.565c.133.027.264.061.4.08.736.1,1.481.155,2.209.3A21.054,21.054,0,0,1,37.968,8.3c.352.45.675.922,1.075,1.471v-.5c0-1.351-.009-2.7.006-4.053A1.572,1.572,0,0,1,40.061,3.7a1.517,1.517,0,0,1,1.757.322,4.178,4.178,0,0,1,.535.863Z",
    transform: "translate(0 0)",
    fill: "#ffa748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2827",
    "data-name": "Trac\\xE9 2827",
    d: "M31.873,18.949c0,2.109-.012,4.219.007,6.328a2.171,2.171,0,0,1-.679,1.661q-3.114,3.087-6.2,6.2a1.708,1.708,0,0,1-1.867.541,1.636,1.636,0,0,1-.786-2.535,4.038,4.038,0,0,1,.388-.428q2.719-2.722,5.445-5.436a1.184,1.184,0,0,0,.4-.929c-.016-3.943-.011-7.887-.009-11.83a1.7,1.7,0,0,1,1.076-1.737,1.65,1.65,0,0,1,2.228,1.59c.016,1.572,0,3.144,0,4.715v1.861",
    transform: "translate(-9.048 -4.387)",
    fill: "#ffa748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2828",
    "data-name": "Trac\\xE9 2828",
    d: "M48.524,66.194a1.727,1.727,0,0,1-1.568-1.284,1.6,1.6,0,0,1,.763-1.8c.538-.3,1.092-.586,1.657-.836a1.631,1.631,0,0,1,2.12.74,1.612,1.612,0,0,1-.606,2.161c-.544.321-1.118.593-1.692.86a3.406,3.406,0,0,1-.674.163",
    transform: "translate(-19.274 -25.53)",
    fill: "#ffa748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2829",
    "data-name": "Trac\\xE9 2829",
    d: "M64.972,43.206a18.424,18.424,0,0,1,.647-2.121,1.549,1.549,0,0,1,1.939-.755,1.566,1.566,0,0,1,1.1,1.732,13.142,13.142,0,0,1-.535,2.073,1.592,1.592,0,0,1-1.89.95,1.728,1.728,0,0,1-1.257-1.88",
    transform: "translate(-26.7 -16.537)",
    fill: "#ffa748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2830",
    "data-name": "Trac\\xE9 2830",
    d: "M59.8,57.6a1.915,1.915,0,0,1-1.471-.941,1.5,1.5,0,0,1,.05-1.681,14.49,14.49,0,0,1,1.3-1.6,1.633,1.633,0,0,1,2.535,2.013,11.01,11.01,0,0,1-1.355,1.658,3.983,3.983,0,0,1-1.061.55",
    transform: "translate(-23.873 -21.746)",
    fill: "#ffa748"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramIcon2);
export default __webpack_public_path__ + "static/media/program-icon-2.06f19228e4517f55ce5e3ed344843c0c.svg";
export { ForwardRef as ReactComponent };